/**
 *
 * @module creditCardType
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class CreditCardType
 *
 */
export default class CreditCardType {

    /**
     *
     * @param {Object} options
     * @param {String} [options.alternateId='']
     * @param {Number} options.id
     * @param {String} options.name
     * @param {Number} [options.primaryId=0]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'CreditCardType(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get id() {
                return `${this.ctor} id should be a Number`;
            },
            get name() {
                return `${this.ctor} name should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { alternateId, id, name, primaryId } = options;

        number(id, errorMessage.id, InvalidArgumentException);
        nonEmptyString(name, errorMessage.name, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.alternateId = Check.string(alternateId) ? alternateId : '';

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = name;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.primaryId = Check.number(primaryId) ? primaryId : 0;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/creditCardType.js